import { render, staticRenderFns } from "./invite-item.vue?vue&type=template&id=42b056e6&scoped=true&"
import script from "./invite-item.vue?vue&type=script&lang=js&"
export * from "./invite-item.vue?vue&type=script&lang=js&"
import style0 from "./invite-item.vue?vue&type=style&index=0&id=42b056e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b056e6",
  null
  
)

export default component.exports